module.exports = __webpack_public_path__ + "img/addTestCase.3653ab23.svg";